import { Observable, from, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService, ToastService } from '../services';
import { Router } from '@angular/router';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly toastService: ToastService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((e) => {
        if ([401, 403].indexOf(e.status) !== -1) {
          this.toastService.showError(
            'Unauthorized! Please login again'
          );
          this.authService.logOut();
          this.router.navigate(['/auth']);
        }
        return throwError(e);
      })
    );
  }
}
 